module.exports = __webpack_public_path__ + "img/symbol_9.56f1a7a4.png";